import { SkapaSmoothScroller } from "./utils/smooth-scroll.js";
import { CarouselFeature } from "./feature-base.js";
import {
  Events as WritingDirectionEvents
} from "./rtl-handler.js";
const Events = {
  UPDATE: "SKAPA_CAROUSEL_SCROLL_UPDATE"
};
class ScrollHandlerFeature extends CarouselFeature {
  constructor(host) {
    super(host);
    /**
     * Scroll snap polyfill for environments that don't support smooth scrolling.
     * However it may needs to be turned off for scrolling by touch elements in pixels.
     * @param offset The offset position the function should find the nearest snap point to.
     * @returns a scroll offset value that will snap to the nearest element's edge.
     */
    this.getNearestSnapTarget = (offset) => {
      const elements = this.host.assignedChildren;
      if (!elements.length)
        return offset;
      let requiredSnapOffset = elements[0].offsetLeft - offset;
      const leftSnapOffsets = [];
      elements.forEach((element) => {
        const distanceStart = element.offsetLeft - offset;
        const distanceEnd = distanceStart + element.offsetWidth - this.host.scrollContainer.clientWidth;
        const closerDistance = Math.abs(distanceStart) > Math.abs(distanceEnd) ? distanceEnd : distanceStart;
        leftSnapOffsets.splice(
          leftSnapOffsets.findIndex((v) => !v || v < requiredSnapOffset),
          0,
          requiredSnapOffset
        );
        if (Math.abs(closerDistance) < Math.abs(requiredSnapOffset))
          requiredSnapOffset = closerDistance;
      });
      return offset + requiredSnapOffset;
    };
    this.animationFrameID = -1;
    this.updateScrollState = () => {
      cancelAnimationFrame(this.animationFrameID);
      this.animationFrameID = requestAnimationFrame(this.onScrollStateUpdate);
    };
    this.onScrollStateUpdate = () => {
      this.onScrollSmoothScrollerCallback(this.host);
      this.dispatchEvent(new ScrollUpdateEvent(this.host));
    };
    // This function is called to synchronise the smooth scroller's position with the actual container's scroll position.
    this.onScrollSmoothScrollerCallback = ({
      scrollLeft
    }) => {
      if (!globalIsResizingFlag)
        this.scroller.debouncedUpdate(scrollLeft);
    };
    this.onWritingDirectionChangeScrollUpdate = ({
      rtl
    }) => {
      this.scroller.isRTL = rtl;
      this.scroller.scrollLeft = this.scrollLeft;
    };
    this.scroller = new SkapaSmoothScroller(host.scrollContainer);
  }
  get scrollLeft() {
    return this.host.scrollContainer.scrollLeft;
  }
  set scrollLeft(value) {
    this.scroller.scrollLeft = value;
  }
  get scrollTarget() {
    return this.scroller.scrollTarget;
  }
  connectedCallback() {
    this.host.features.resizeHandler.addEventListener(
      "SKAPA_CAROUSEL_RESIZE_EVENT",
      updateIsResizingState
    );
    this.host.features.writingDirection.addEventListener(
      WritingDirectionEvents.CHANGE,
      this.onWritingDirectionChangeScrollUpdate
    );
    this.host.scrollContainer.addEventListener(
      "scroll",
      this.updateScrollState
    );
    this.updateScrollState();
  }
  disconnectedCallback() {
    this.host.features.resizeHandler.removeEventListener(
      "SKAPA_CAROUSEL_RESIZE_EVENT",
      updateIsResizingState
    );
    this.host.scrollContainer.removeEventListener(
      "scroll",
      this.updateScrollState
    );
    this.scroller.stopAnimations();
  }
}
let globalIsResizingFlag = false;
function updateIsResizingState({ finished }) {
  globalIsResizingFlag = !finished;
}
class ScrollUpdateEvent extends Event {
  constructor(host) {
    super(Events.UPDATE, { bubbles: false });
    this.clientWidth = host.scrollContainer.clientWidth;
    this.scrollLeft = host.scrollLeft;
    this.scrollWidth = host.scrollWidth;
  }
}
export {
  Events,
  ScrollHandlerFeature,
  ScrollUpdateEvent
};
